import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ResultActions from "../../../redux/Actions/Results.action";
import toast from "react-hot-toast";

import { H2 } from "../../../Components/Texts/Textes";
import { Button, ButtonOutline } from "../../../Components/buttons/Buttons";
import {
  CheckBox_Field as CheckBoxField,
  CheckBox_Field_other as CheckBoxFieldOther,
} from "../../../Components/input/CheckBox_Field";

import white_arrow from "../../../Assets/Images/icons/white_arrow.svg";
import blue_arrow from "../../../Assets/Images/icons/blue_arrow.svg";

import Data from "../../../data/fake.data";
import { have, SelectN, isAll } from "../../../Functions/Arrays.functions";

import styles from "./styles.module.scss";

function Question4(props) {
  const { handle_next, handle_prev } = props;
  const data = Data.Question4;
  const dispatch = useDispatch();

  const [selected, setSelected] = useState([-1]);

  const [isnon, setIsNon] = useState(false);

  const handle_choose = (key) => {
    setIsNon(false);
    let new_select = SelectN(selected, key);
    setSelected(new_select);
  };

  const handleSubitQuestion = () => {
    if (isAll(selected, -1) && !isnon) {
      toast.error("please select at least 1 option"); // snack
      return;
    }

    if (isnon) {
      handle_next();
      return;
    }

    let answers = [];
    selected.forEach((pos) => {
      if (pos !== -1 && pos !== data.answers.length - 1) {
        answers.push(data.answers[pos]);
      }
    });

    dispatch(ResultActions.ChangeQ4([...answers]));

    handle_next();
  };

  return (
    <div className={styles.question}>
      <H2>{data.title}</H2>
      <span className={styles.info}>{data.hint}</span>
      <div className={styles.form}>
        {data.answers.map((item, key) => {
          return (
            <div key={key}>
              <CheckBoxField
                check={have(selected, key)}
                onClick={() => {
                  handle_choose(key);
                }}
              >
                {item}
              </CheckBoxField>

              {/*key === data.answers.length - 1 && (
                <CheckBoxFieldOther
                  check={have(selected, key)}
                  onClick={() => {
                    handle_choose(key);
                  }}
                  onChange={handle_other_change}
                  value={other}
                >
                  {item}
                </CheckBoxFieldOther>
                )*/}
            </div>
          );
        })}

        <div className={styles.buttons}>
          <ButtonOutline className={styles.prev} onClick={handle_prev}>
            <img src={blue_arrow} alt="previus" />
          </ButtonOutline>
          <Button className={styles.btn_next} onClick={handleSubitQuestion}>
            Next <img src={white_arrow} alt="next" />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Question4;
